import { render, staticRenderFns } from "./PopupPhoneCall.vue?vue&type=template&id=d99be4d4&scoped=true&"
import script from "./PopupPhoneCall.vue?vue&type=script&lang=js&"
export * from "./PopupPhoneCall.vue?vue&type=script&lang=js&"
import style0 from "./PopupPhoneCall.vue?vue&type=style&index=0&id=d99be4d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99be4d4",
  null
  
)

export default component.exports